import React from 'react';
import '../../scss/components/_ebook-card.scss'

class EBookCard extends React.Component {
    constructor(props){
      super(props);
      this.state = { width: (typeof window !== 'undefined') ? window.innerWidth : 0 };
    }

    updateDimensions = () => {
      this.setState({ width: (typeof window !== 'undefined') ? window.innerWidth : 0 });
    };

    componentWillMount(){
      if (typeof window !== 'undefined'){
        window.addEventListener('resize', this.updateDimensions);
      }
    }
    componentWillUnmount(){
      if (typeof window !== 'undefined'){
        window.removeEventListener('resize', this.updateDimensions);
      }
    }

    render() {
    return (
            <React.Fragment>
            <a href={this.props.readMoreLink} target="_blank">
            <div className="image-container">
              <div className="icon">
                <img src={'/resources/external-link-icon.svg'} alt="Icon external link"/>
              </div>
              <div className="guide-image" style={this.state.width>"660" | this.state.width<"440" ? imgUrl(this.props.urlImgDesktop,"left top") : imgUrl(this.props.urlImgMobile,"center")}></div>
            </div>
            </a>  
            <div className="guide-text">
              {this.props.title}
            </div> 
            <div className="guide-footer"> 
              <p> <a href={this.props.readMoreLink} target="_blank" className="ctaStandard"> {this.props.readMoreText} </a></p>
            </div>
            </React.Fragment>
    )
  }
}

const imgUrl=(url,imagePosition) =>({
    backgroundImage : `url(${url})`,
    backgroundPosition: imagePosition
})

export default EBookCard;
    